import type { GridViewPreference } from '../../../../api/userPreferencesApi'

export const TIME_ENTRY_CREATION_QUESTION =
  'How would you like MIRA to prepare your time entries?'

export type TimeEntryCreationOption = {
  value: GridViewPreference
  title: string
  recommendation: string
  summary: string
  description: string
}

// Shared by Settings > Time Entry Creation and the first-run preference popup
// so both always show the same copy.
export const TIME_ENTRY_CREATION_OPTIONS: TimeEntryCreationOption[] = [
  {
    value: 'matter',
    title: 'Guided Review',
    recommendation: '(Recommended for maximum control)',
    summary:
      'Best for attorneys who want maximum control over their time entries.',
    description:
      'MIRA continuously captures and groups your work throughout the day, then presents suggested time entries for review. You decide how activities are grouped, adjust time as needed, and create the final time entry. Once saved, the entry is immediately accepted.',
  },
  {
    value: 'time',
    title: 'Auto Draft',
    recommendation: '(Recommended for automation first)',
    summary:
      'Best for attorneys who want the fastest path from work to billable time.',
    description:
      'MIRA automatically creates draft time entries based on captured activity and grouped work. Simply review, make any adjustments, and approve when ready.',
  },
]
